export default "/app/global-wrapper-client/static/c1acf1ffec295041645f90b7410cad7e.woff2";